@if ({
  sidebar: (slideViewerFacade.currentSelectedSlideSidebarSize$ | async),
  sidebarFull: (slideViewerFacade.currentSelectedSlideSidebarFullSize$ | async),
  main: (slideViewerFacade.currentSelectedSlideMainSize$ | async),
  mainFull: (slideViewerFacade.currentSelectedSlideMainFullSize$ | async)
  }; as size) {
  <article class="d-flex h-100 w-100">
    @if ((menuSharedFacade.showFullscreen$ | async) === false && size.mainFull === false) {
      <medsurf-slide-sidebar class="flex-grow-{{size.sidebar}}"
        >
      </medsurf-slide-sidebar>
    }
    @if (size.sidebarFull === false && (slideViewerFacade.currentSelectedSlideMedia$ | async); as media) {
      <div class="main-content h-100 flex-grow-{{size.main}}"
        >
        <!-- Video -->
        @if (mediaControlService.isVideo(media)) {
          <medsurf-video class="h-100"
            [media]="media">
          </medsurf-video>
        }
        <!-- Audio -->
        @if (mediaControlService.isAudio(media)) {
          <medsurf-audio class="h-100"
            [media]="media">
          </medsurf-audio>
        }
        <!-- Image -->
        @if (mediaControlService.isDeepzoom(media) || mediaControlService.isImage(media)) {
          <medsurf-image class="h-100"
            >
          </medsurf-image>
        }
        <!-- -->
        <!-- Sequence Control -->
        @if ((slideViewerFacade.currentSelectedSlideHasSequenceControl$ | async) || (slideViewerFacade.currentSelectedSlideLayers$ | async)?.length > 1) {
          <medsurf-sequence-control></medsurf-sequence-control>
        }
        <!-- Shortcuts -->
        @if (mediaControlService.isDeepzoom(media) || mediaControlService.isImage(media)) {
          <medsurf-shortcuts></medsurf-shortcuts>
        }
      </div>
    }
  </article>
}
